/* BSlay Atelier — theme scripts */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  if (window.Shopify && window.Shopify.designMode) document.documentElement.classList.add('shopify-design-mode');

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = (Number(cents) / 100);
    function withDelimiters(num, precision, thousands, decimal) {
      var parts = num.toFixed(precision).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(precision ? decimal : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var out;
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': out = withDelimiters(value, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = withDelimiters(value, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = withDelimiters(value, 0, '.', ','); break;
      default: out = withDelimiters(value, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg) {
    var el = $('#Toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- Drawers ---------- */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    var focusable = d.querySelector('button, a, input');
    if (focusable) setTimeout(function () { focusable.focus(); }, 50);
  }
  function closeDrawer(d) {
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open') && !$('.search-overlay.is-open')) document.body.classList.remove('overflow-hidden');
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open')); return; }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) { closeDrawer(closer.closest('.drawer')); }
  });
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (lightbox && lightbox.classList.contains('is-open')) { closeLightbox(); return; }
      $$('.drawer.is-open').forEach(closeDrawer);
      closeSearch();
      return;
    }
    if (e.key !== 'Tab') return;
    var trap = $('.lightbox.is-open') || $('.drawer.is-open .drawer__panel') || $('.search-overlay.is-open .search-overlay__panel');
    if (!trap) return;
    var items = $$(FOCUSABLE, trap).filter(function (el) { return el.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || !trap.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !trap.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
  });

  /* ---------- Header scroll state ---------- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Announcement rotator ---------- */
  $$('[data-announcement]').forEach(function (wrap) {
    var slides = $$('.announcement__slide', wrap);
    if (slides.length < 2) return;
    var i = 0;
    var speed = (parseInt(wrap.getAttribute('data-speed'), 10) || 5) * 1000;
    setInterval(function () {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, speed);
  });

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Tabs ---------- */
  $$('[data-tabs]').forEach(function (wrap) {
    var buttons = $$('[role="tab"]', wrap);
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) {
          var selected = b === btn;
          b.setAttribute('aria-selected', selected ? 'true' : 'false');
          var panel = document.getElementById(b.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        });
      });
    });
  });

  /* ---------- Cart ---------- */
  var cartDrawer = $('#CartDrawer');
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = count === 0; });
    $$('[data-cart-count-label]').forEach(function (el) { el.textContent = '(' + count + ')'; });
  }
  function renderDrawer(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-contents]');
    var inner = $('[data-cart-drawer-inner]');
    if (fresh && inner) {
      inner.innerHTML = '';
      inner.appendChild(fresh);
      updateCount(parseInt(fresh.getAttribute('data-count'), 10) || 0);
    }
  }
  function renderCartPage(html) {
    var page = $('[data-cart-page]');
    if (!page || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-page]');
    if (fresh) page.innerHTML = fresh.innerHTML;
  }
  function cartSections() {
    var list = ['cart-drawer-contents'];
    var page = $('[data-cart-page]');
    if (page && page.getAttribute('data-section-id')) list.push(page.getAttribute('data-section-id'));
    return list;
  }
  function renderSections(sections) {
    if (!sections) return;
    if (sections['cart-drawer-contents']) renderDrawer(sections['cart-drawer-contents']);
    var page = $('[data-cart-page]');
    if (page && sections[page.getAttribute('data-section-id')]) renderCartPage(sections[page.getAttribute('data-section-id')]);
  }
  function refreshCart(open) {
    return fetch(window.theme.routes.root + '?section_id=cart-drawer-contents')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        renderDrawer(html);
        if (open && cartDrawer) openDrawer('CartDrawer');
      });
  }
  var cartBusy = false;
  function changeLine(key, qty, row) {
    if (cartBusy) return;
    cartBusy = true;
    if (row) row.classList.add('is-loading');
    return fetch(window.theme.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: cartSections(), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) {
          toast(res.data.description || res.data.message || 'That quantity is not available');
          return fetch(window.location.pathname + '?sections=' + cartSections().join(','))
            .then(function (r) { return r.json(); })
            .then(renderSections);
        }
        renderSections(res.data.sections);
      })
      .catch(function () { toast('Something went wrong. Please try again.'); if (row) row.classList.remove('is-loading'); })
      .finally(function () { cartBusy = false; });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cart-open]');
    if (opener && cartDrawer && !document.body.classList.contains('template-cart')) {
      e.preventDefault();
      openDrawer('CartDrawer');
      return;
    }
    var lineBtn = e.target.closest('[data-line-change]');
    if (lineBtn) {
      e.preventDefault();
      var qty = Math.max(0, parseInt(lineBtn.getAttribute('data-qty'), 10) || 0);
      changeLine(lineBtn.getAttribute('data-line-change'), qty, lineBtn.closest('.cart-item'));
    }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-input]');
    if (!input) return;
    changeLine(input.getAttribute('data-line-input'), Math.max(0, parseInt(input.value, 10) || 0), input.closest('.cart-item'));
  });

  /* Add to cart (product page + quick add) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form || !cartDrawer) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.classList.add('loading');
    var sticky = $('[data-sticky-add]');
    if (sticky && sticky.getAttribute('form') === form.id) sticky.classList.add('loading');
    fetch(window.theme.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.data.description || res.data.message || 'Could not add to bag'); return; }
        return refreshCart(true);
      })
      .catch(function () { toast('Something went wrong. Please try again.'); })
      .finally(function () {
        if (btn) btn.classList.remove('loading');
        if (sticky) sticky.classList.remove('loading');
      });
  });

  /* Quantity steppers on product page */
  $$('[data-qty]').forEach(function (wrap) {
    var input = $('input', wrap);
    var minus = $('[data-qty-minus]', wrap);
    var plus = $('[data-qty-plus]', wrap);
    if (!input || !minus || !plus) return;
    minus.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
    plus.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
  });

  /* ---------- Product gallery ---------- */
  $$('[data-gallery]').forEach(function (gallery) {
    var track = $('[data-gallery-track]', gallery);
    var thumbs = $$('[data-thumb]', gallery);
    var slides = $$('.gallery__slide', track);
    if (!track || slides.length < 2) return;
    var counter = $('[data-gallery-counter]', gallery);

    function goTo(index) {
      index = (index + slides.length) % slides.length;
      track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    }
    function currentIndex() { return Math.round(track.scrollLeft / track.clientWidth); }
    track.addEventListener('scroll', function () {
      var idx = currentIndex();
      thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
      if (counter) counter.textContent = (idx + 1) + ' / ' + slides.length;
    }, { passive: true });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    var prev = $('[data-gallery-prev]', gallery);
    var next = $('[data-gallery-next]', gallery);
    if (prev) prev.addEventListener('click', function () { goTo(currentIndex() - 1); });
    if (next) next.addEventListener('click', function () { goTo(currentIndex() + 1); });

    gallery.goToMedia = function (mediaId) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === String(mediaId)) { goTo(i); return; }
      }
    };
  });

  /* ---------- Variant picker ---------- */
  $$('[data-product-section]').forEach(function (section) {
    var picker = $('[data-variant-picker]', section);
    var form = $('[data-product-form]', section);
    if (!picker || !form) return;
    var variants = [];
    try { variants = JSON.parse($('[data-variants]', picker).textContent); } catch (err) { return; }
    var idInput = $('[data-variant-id]', form);
    var addBtn = $('[data-add-button]', form);
    var addLabel = $('[data-add-label]', form);
    var priceWrap = $('[data-product-price]', section);
    var saveEl = $('[data-product-save]', section);
    var inv = $('[data-inventory]', section);
    var sticky = $('[data-sticky-atc]');
    var stickyPrice = sticky && $('[data-sticky-price]', sticky);
    var stickyAdd = sticky && $('[data-sticky-add]', sticky);
    var gallery = $('[data-gallery]', section);
    var optionCount = $$('fieldset', picker).length;

    function selectedOptions() {
      var opts = [];
      for (var i = 0; i < optionCount; i++) {
        var checked = picker.querySelector('input[data-option-index="' + i + '"]:checked');
        opts.push(checked ? checked.value : null);
      }
      return opts;
    }
    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function markAvailability(opts) {
      $$('input[data-option-index]', picker).forEach(function (input) {
        var idx = parseInt(input.getAttribute('data-option-index'), 10);
        var available = variants.some(function (v) {
          if (!v.available || v.options[idx] !== input.value) return false;
          for (var i = 0; i < idx; i++) { if (v.options[i] !== opts[i]) return false; }
          return true;
        });
        input.classList.toggle('is-unavailable', !available);
      });
    }
    function update() {
      var opts = selectedOptions();
      opts.forEach(function (val, i) {
        var label = picker.querySelector('[data-option-value="' + i + '"]');
        if (label) label.textContent = val || '';
      });
      markAvailability(opts);
      var v = findVariant(opts);
      if (!v) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Unavailable';
        if (stickyAdd) stickyAdd.disabled = true;
        return;
      }
      idInput.value = v.id;
      $$('input[name="id"]', section).forEach(function (i) { i.value = v.id; });
      if (addBtn) addBtn.disabled = !v.available;
      if (addLabel) addLabel.textContent = v.available ? 'Add to bag' : 'Sold out';
      if (stickyAdd) stickyAdd.disabled = !v.available;
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (priceWrap) {
        priceWrap.innerHTML = '<div class="price">' + (onSale
          ? '<span class="price__sale">' + formatMoney(v.price) + '</span><s class="price__compare">' + formatMoney(v.compare_at_price) + '</s>'
          : '<span class="price__regular">' + formatMoney(v.price) + '</span>') + '</div>';
      }
      if (saveEl) {
        saveEl.hidden = !onSale;
        if (onSale) saveEl.textContent = 'Save ' + formatMoney(v.compare_at_price - v.price);
      }
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
      if (inv) {
        inv.classList.remove('is-low', 'is-out');
        if (!v.available) { inv.classList.add('is-out'); inv.textContent = 'Sold out'; }
        else { inv.textContent = 'In stock, ready to ship'; }
      }
      if (v.featured_media && gallery && gallery.goToMedia) gallery.goToMedia(v.featured_media.id);
      var url = section.getAttribute('data-product-url');
      if (url && window.history.replaceState) window.history.replaceState({}, '', url + '?variant=' + v.id);
    }
    picker.addEventListener('change', update);
    markAvailability(selectedOptions());
  });

  /* Sticky add-to-cart on mobile */
  var stickyBar = $('[data-sticky-atc]');
  var mainAdd = $('[data-add-button]');
  if (stickyBar && mainAdd) {
    var stickyTick = false;
    var checkSticky = function () {
      stickyTick = false;
      var show = mainAdd.getBoundingClientRect().bottom < 0;
      if (show === stickyBar.classList.contains('is-visible')) return;
      stickyBar.classList.toggle('is-visible', show);
      stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
    };
    window.addEventListener('scroll', function () { if (!stickyTick) { stickyTick = true; requestAnimationFrame(checkSticky); } }, { passive: true });
    checkSticky();
  }

  /* Copy link */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-copy-link]');
    if (!btn) return;
    if (navigator.clipboard) navigator.clipboard.writeText(btn.getAttribute('data-copy-link')).then(function () { toast('Link copied'); });
  });

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.querySelector('.card')) {
        el.innerHTML = fresh.innerHTML;
        el.classList.add('is-loaded');
      }
    }).catch(function () {});
  });

  /* ---------- Collection filters & sort ---------- */
  function applyFilters(form) {
    var params = new URLSearchParams(new FormData(form));
    var sort = $('[data-sort]');
    if (sort) params.set('sort_by', sort.value);
    Array.from(params.keys()).forEach(function (k) { if (params.get(k) === '') params.delete(k); });
    window.location.search = params.toString();
  }
  $$('[data-filter-form]').forEach(function (form) {
    var t;
    form.addEventListener('change', function () { clearTimeout(t); t = setTimeout(function () { applyFilters(form); }, 350); });
    form.addEventListener('submit', function (e) { e.preventDefault(); applyFilters(form); });
  });
  var sortSel = $('[data-sort]');
  if (sortSel) {
    sortSel.addEventListener('change', function () {
      var form = $('[data-filter-form]');
      if (form) { applyFilters(form); return; }
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', sortSel.value);
      window.location.search = params.toString();
    });
  }

  /* ---------- Search overlay + predictive search ---------- */
  var overlay = $('#SearchOverlay');
  function openSearch() {
    if (!overlay) return;
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    var input = $('[data-predictive-input]', overlay);
    if (input) setTimeout(function () { input.focus(); }, 80);
  }
  function closeSearch() {
    if (!overlay || !overlay.classList.contains('is-open')) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('overflow-hidden');
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); }
    else if (e.target.closest('[data-search-close]')) { closeSearch(); }
  });
  var pInput = overlay && $('[data-predictive-input]', overlay);
  var pResults = overlay && $('[data-predictive-results]', overlay);
  var pDefault = overlay && $('[data-predictive-default]', overlay);
  if (pInput && pResults) {
    var pt;
    var escapeHtml = function (s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; };
    pInput.addEventListener('input', function () {
      clearTimeout(pt);
      var q = pInput.value.trim();
      if (q.length < 2) { pResults.innerHTML = ''; if (pDefault) pDefault.hidden = false; return; }
      pt = setTimeout(function () {
        fetch(window.theme.routes.predictiveSearch + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=8&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (pInput.value.trim() !== q) return;
            var res = (data.resources && data.resources.results) || {};
            var products = res.products || [];
            var collections = res.collections || [];
            var queries = res.queries || [];
            var searchUrl = window.theme.routes.search + '?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(q);
            var hasAny = products.length || collections.length || queries.length;
            if (pDefault) pDefault.hidden = !!hasAny;
            if (!hasAny) { pResults.innerHTML = '<p class="predictive-empty">No matches for “' + escapeHtml(q) + '” yet. Try “bob”, “curly” or “glueless”.</p>'; return; }
            var html = '';
            var chips = queries.slice(0, 4).map(function (s) {
              return '<a class="chip" href="' + s.url + '">' + escapeHtml(s.text) + '</a>';
            }).concat(collections.slice(0, 4).map(function (c) {
              return '<a class="chip chip--collection" href="' + c.url + '">' + escapeHtml(c.title) + '</a>';
            }));
            if (chips.length) html += '<p class="search-suggest__label" style="margin-top:1.5rem">Suggestions</p><div class="search-suggest__chips">' + chips.join('') + '</div>';
            if (products.length) {
              html += '<p class="search-suggest__label" style="margin-top:1.5rem">Products</p><div class="predictive-results">' + products.map(function (p) {
                var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=400" alt="" loading="lazy">' : '';
                var compare = parseFloat(p.compare_at_price_max || 0) > parseFloat(p.price) ? ' <s class="price__compare">' + formatMoney(Math.round(parseFloat(p.compare_at_price_max) * 100)) + '</s>' : '';
                return '<a class="predictive-item" href="' + p.url + '">' + img + '<span>' + escapeHtml(p.title) + '</span><strong>' + formatMoney(Math.round(parseFloat(p.price) * 100)) + compare + '</strong></a>';
              }).join('') + '</div>';
            }
            html += '<a class="link-arrow predictive-all" href="' + searchUrl + '">See all results for “' + escapeHtml(q) + '”</a>';
            pResults.innerHTML = html;
          })
          .catch(function () {});
      }, 220);
    });
  }
  /* ---------- Product image lightbox ---------- */
  var lightbox = $('#Lightbox');
  var lbImages = [], lbIndex = 0, lbGallery = null, lbLastFocus = null;
  function showLightboxImage() {
    var img = $('[data-lightbox-img]', lightbox);
    var stage = $('[data-lightbox-stage]', lightbox);
    stage.classList.remove('is-zoomed');
    img.style.transformOrigin = '';
    img.src = lbImages[lbIndex];
    var count = $('[data-lightbox-count]', lightbox);
    if (count) count.textContent = lbImages.length > 1 ? (lbIndex + 1) + ' / ' + lbImages.length : '';
    $$('.lightbox__prev, .lightbox__next', lightbox).forEach(function (b) { b.hidden = lbImages.length < 2; });
  }
  function openLightbox(gallery, mediaIndex) {
    if (!lightbox) return;
    var all = [];
    try { all = JSON.parse($('[data-zoom-images]', gallery).textContent); } catch (err) { return; }
    lbImages = all.filter(Boolean);
    if (!lbImages.length) return;
    var target = all[mediaIndex];
    lbIndex = Math.max(0, lbImages.indexOf(target));
    lbGallery = gallery;
    lbLastFocus = document.activeElement;
    showLightboxImage();
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    setTimeout(function () { $('[data-lightbox-close]', lightbox).focus(); }, 50);
  }
  function closeLightbox() {
    if (!lightbox || !lightbox.classList.contains('is-open')) return;
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open') && !$('.search-overlay.is-open')) document.body.classList.remove('overflow-hidden');
    if (lbLastFocus) lbLastFocus.focus();
  }
  function stepLightbox(dir) { lbIndex = (lbIndex + dir + lbImages.length) % lbImages.length; showLightboxImage(); }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-zoom-open]');
    var img = !opener && e.target.closest('.gallery__slide img[data-zoom]');
    if (opener || img) {
      var gallery = e.target.closest('[data-gallery]');
      var idx = opener ? parseInt(opener.getAttribute('data-zoom-open'), 10) : $$('.gallery__slide', gallery).indexOf(img.closest('.gallery__slide'));
      openLightbox(gallery, idx);
      return;
    }
    if (!lightbox || !lightbox.classList.contains('is-open')) return;
    if (e.target.closest('[data-lightbox-close]')) { closeLightbox(); return; }
    if (e.target.closest('[data-lightbox-prev]')) { stepLightbox(-1); return; }
    if (e.target.closest('[data-lightbox-next]')) { stepLightbox(1); return; }
    var stageImg = e.target.closest('[data-lightbox-img]');
    if (stageImg) {
      var stage = stageImg.parentNode;
      if (!stage.classList.contains('is-zoomed')) {
        var rect = stageImg.getBoundingClientRect();
        stageImg.style.transformOrigin = ((e.clientX - rect.left) / rect.width * 100) + '% ' + ((e.clientY - rect.top) / rect.height * 100) + '%';
      }
      stage.classList.toggle('is-zoomed');
      return;
    }
    if (e.target === lightbox || e.target.closest('[data-lightbox-stage]')) closeLightbox();
  });
  if (lightbox) {
    lightbox.addEventListener('mousemove', function (e) {
      var stage = $('[data-lightbox-stage]', lightbox);
      if (!stage.classList.contains('is-zoomed')) return;
      var img = $('[data-lightbox-img]', lightbox);
      var rect = stage.getBoundingClientRect();
      img.style.transformOrigin = ((e.clientX - rect.left) / rect.width * 100) + '% ' + ((e.clientY - rect.top) / rect.height * 100) + '%';
    });
    var touchX = null;
    lightbox.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
    lightbox.addEventListener('touchend', function (e) {
      if (touchX === null || $('.lightbox__stage.is-zoomed', lightbox)) return;
      var dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 50 && lbImages.length > 1) stepLightbox(dx < 0 ? 1 : -1);
      touchX = null;
    }, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'ArrowLeft') stepLightbox(-1);
      if (e.key === 'ArrowRight') stepLightbox(1);
    });
  }

  /* ---------- Back to top ---------- */
  var toTop = $('[data-back-to-top]');
  if (toTop) {
    window.addEventListener('scroll', function () { toTop.classList.toggle('is-visible', window.scrollY > window.innerHeight * 1.5); }, { passive: true });
    toTop.addEventListener('click', function (e) { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* ---------- Recently viewed ---------- */
  var RV_KEY = 'bslay:recently-viewed';
  function readRecent() { try { return JSON.parse(localStorage.getItem(RV_KEY)) || []; } catch (err) { return []; } }
  var productSection = $('[data-product-section]');
  if (productSection) {
    var handle = (productSection.getAttribute('data-product-url') || '').split('/products/').pop().split('?')[0];
    if (handle) {
      var list = readRecent().filter(function (h) { return h !== handle; });
      list.unshift(handle);
      try { localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 12))); } catch (err) {}
    }
  }
  $$('[data-recently-viewed]').forEach(function (wrap) {
    var current = wrap.getAttribute('data-current');
    var limit = parseInt(wrap.getAttribute('data-limit'), 10) || 4;
    var handles = readRecent().filter(function (h) { return h && h !== current; }).slice(0, limit);
    var ul = $('[data-recently-viewed-list]', wrap);
    if (!handles.length || !ul) return;
    Promise.all(handles.map(function (h) {
      return fetch(window.theme.routes.root.replace(/\/$/, '') + '/products/' + encodeURIComponent(h) + '?section_id=card-ajax')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (htmls) {
      var cards = htmls.map(function (html) {
        if (!html) return '';
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var card = doc.querySelector('.card');
        return card ? '<li>' + card.outerHTML + '</li>' : '';
      }).filter(Boolean);
      if (!cards.length) return;
      ul.innerHTML = cards.join('');
      wrap.hidden = false;
    });
  });
})();
